import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ServiceTypeForm } from '@/components/forms/ServiceTypeForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function ServiceTypeCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/service-catalog/service-types')
  }

  const handleCancel = () => {
    navigate('/service-catalog/service-types')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex={1}>
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create Service Type</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new service type or category to the catalog
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex={1} minH={0}>
              <ServiceTypeForm onSuccess={handleSuccess} onCancel={handleCancel} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AdminLayout>
  )
}
